export default __webpack_public_path__ + "static/media/apollo.3617e2fa.png";